// Centrale vertaling van interne BTW veld-waarden naar Nederlandstalige
// labels voor weergave (admin + klant-portaal). DB-waarden blijven hetzelfde
// zodat bestaande aanvragen niet gemigreerd hoeven worden; alleen de display
// is hier gemapt.

// Batterij-gebruik. De eerste vier zijn de huidige form-opties; de laatste
// drie zijn legacy-waarden uit oudere aanvragen die we netjes blijven tonen.
export const BATTERY_USAGE_LABELS = {
  trading: "Energie handel",
  zelfgebruik: "Eigen verbruik",
  beide: "Beide (eigen verbruik + handel)",
  verhuurd: "Verhuurd aan energiemaatschappij",
  prive: "Privé",
  "privé": "Privé",
  zakelijk: "Zakelijk",
  gemengd: "Gemengd",
};

export const batteryUsageLabel = (value) =>
  BATTERY_USAGE_LABELS[value] ?? value ?? "";

// Ondernemerschap-veld (step 2).
export const IS_ENTREPRENEUR_LABELS = {
  ja: "Ja",
  nee: "Nee",
  ja_geen_btw: "Ja, maar zonder BTW-aangiften",
};

// Bedrijfsvorm (step 2).
export const BUSINESS_FORM_LABELS = {
  zzp: "ZZP",
  bv_vof_maatschap: "BV / VOF / Maatschap",
};

// Geslacht (step 1).
export const GENDER_LABELS = {
  man: "Man",
  vrouw: "Vrouw",
  anders: "Anders",
};

export const genderLabel = (value) => GENDER_LABELS[value] ?? value ?? "";

// Step-2 kwalificatievragen: per vraag-key een mapping van waarde → label.
// Niet elke vraag is een simpele ja/nee, dus context-aware mapping is nodig
// om uitkomsten zoals "Vóór 1-1-2020" of "Ja, maar zonder BTW-aangiften"
// correct te tonen.
const YES_NO_LABELS = { ja: "Ja", nee: "Nee", na: "n.v.t." };
const STEP2_VALUE_LABELS = {
  previousVat: YES_NO_LABELS,
  previousInstall: { voor: "Vóór 1-1-2020", na: "Na 1-1-2020" },
  moved: YES_NO_LABELS,
  oldHouseSold: YES_NO_LABELS,
  hasPartner: YES_NO_LABELS,
  partnerEntrepreneur: YES_NO_LABELS,
  partnerFutureEntrepreneur: YES_NO_LABELS,
  isEntrepreneur: IS_ENTREPRENEUR_LABELS,
  businessForm: BUSINESS_FORM_LABELS,
  futureEntrepreneur: YES_NO_LABELS,
  vatThreshold: YES_NO_LABELS,
};

export const step2ValueLabel = (key, value) => {
  if (value === undefined || value === null || value === "") return "-";
  const map = STEP2_VALUE_LABELS[key];
  if (map && map[value]) return map[value];
  return String(value);
};
